import React from 'react';
import { node } from 'prop-types';
import MainPageLayout from '../../templates/MainPageLayout';
import PageHeaderContainer from '../../../containers/PageHeaderContainer';
import PageFooterContainer from '../../../containers/PageFooterContainer';
import ContentsContainer from '../../../containers/ContentsContainer';
import ErrorBoundary from '../ErrorBoundary';

const MainPage = ()=>{
	return <MainPageLayout 
		renderHeader={(sidebarProps)=><PageHeaderContainer 
			isMenuOpened={sidebarProps.isSidebarOpen}
			onOpenSidebar={sidebarProps.onOpenSidebar}
		/>}
		renderMain={()=>
			<ErrorBoundary>
				<ContentsContainer />
			</ErrorBoundary>
		}
		renderFooter={()=><PageFooterContainer/>}
	/>;
};

MainPage.propTypes = {
	children : node,
};

export default MainPage;